const readMoreSections = document.querySelectorAll(".read-more__text");
readMoreSections.forEach(section => {
  const wrapper = section.parentNode;
  const readMoreButton = wrapper.querySelector('.read-more');

  if (readMoreButton) {
    readMoreButton.addEventListener('click', function () {
      section.classList.toggle('show-more');
      if (section.classList.contains('show-more')) {
        readMoreButton.textContent = 'Weniger lesen';
      } else {
        readMoreButton.textContent = 'Mehr lesen';
      }
    });
  }
})


const counter = document.querySelector(".counter__value");
if (counter) {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: .8
  };
  
  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        runCounter();
        observer.disconnect();
      }
    });
  }
  
  new IntersectionObserver(handleIntersection, options).observe(counter);
  
  let currentCount = 0;
  let targetCount = counter.dataset.target;
  const sleep = ms => new Promise(r => setTimeout(r, ms));
  let step = 1;
  let stepTime = .1;
  
  async function runCounter () {
    while (currentCount < targetCount) {
      currentCount += step;
      counter.textContent = currentCount.toLocaleString("en-US").replaceAll(",", ".");
      const percentageCounted = currentCount / targetCount * 100;
      if (percentageCounted < 30) {
        step = 10;
        stepTime = 1; 
      }
      else if (percentageCounted < 60) {
        step = 5;
        stepTime = 1; 
      }
      else if (percentageCounted < 95) {
        step = 5;
        stepTime = 2; 
      }
      else if (percentageCounted < 99) {
        step = 1;
        stepTime = 5; 
      }
      else {
        stepTime = 100; 
      }
      await sleep(stepTime)
    } 
  }
  
  const counterInfo = document.querySelector(".counter__info")
  const counterInfoPopup = document.querySelector(".counter__info-popup")
  
  if (counterInfoPopup) {
    counterInfo.addEventListener("click", function() {
      counterInfoPopup.classList.add('show');
    })
    document.querySelector(".counter__info-close").addEventListener("click", function(e) {
      counterInfoPopup.classList.remove('show');
    })
  }
}